import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { HeaderProps } from "src/utils/interfaces";

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const botonIzq = props.botonIzq ? (
    <IonButton routerLink={props.botonIzq.url} onClick={props.botonIzq.action}>
      <IonIcon
        slot="icon-only"
        icon={props.botonIzq.icono}
        src={props.botonIzq.src}
      ></IonIcon>
    </IonButton>
  ) : (
    <IonMenuButton />
  );

  let botonesDerecha;
  if (props.botonesDerecha) {
    botonesDerecha = props.botonesDerecha.map((boton, idx) => (
      <IonButton key={idx} routerLink={boton.url} onClick={boton.action}>
        <IonIcon slot="icon-only" icon={boton.icono} src={boton.src}></IonIcon>
      </IonButton>
    ));
  } else botonesDerecha = "";

  return (
    <IonHeader>
      <div className="container px-0">
        <IonToolbar color="primary">
          <IonButtons slot="start">{botonIzq}</IonButtons>
          <IonTitle>{props.titulo}</IonTitle>
          <IonButtons slot="end">{botonesDerecha}</IonButtons>
        </IonToolbar>
      </div>
    </IonHeader>
  );
};

export default Header;
